
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/effect",
      function () {
        return require("private-next-pages/effect/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/effect"])
      });
    }
  